<template>
  <div>
    <b-card :title="report.title">
      <b-card-text>
        <div>
          <b-button
            class="mr-3"
            variant="primary"
            v-b-modal.modal-1
            v-if="report.params && report.params.length > 0"
          >
            <b-icon icon="search"></b-icon>
          </b-button>
          <b-button class="mr-3" variant="primary" @click="getData()">
            <b-icon icon="arrow-repeat"></b-icon>
          </b-button>
          <b-button
            variant="success"
            :href="'#' + item.link"
            v-for="item in getButtons(1)"
            v-bind:key="item.id"
            >{{ item.title }}</b-button
          >

          <b-modal
            id="modal-1"
            title="جستجو"
            ok-title="جستجو"
            cancel-title="انصراف"
            @ok="getData()"
          >
            <div v-for="item in report.params" v-bind:key="item.id">
              <b-form-group
                v-if="item.type == 1"
                :id="'input-group-' + item.id"
                :label="item.title"
                :label-for="'input-' + item.id"
              >
                <b-form-input
                  :id="'input-' + item.id"
                  v-model="item.value"
                  type="text"
                  required
                  placeholder
                ></b-form-input>
              </b-form-group>
              <b-form-group
                v-if="item.type == 2"
                :id="'input-group-' + item.id"
                :label="item.title"
                :label-for="'input-' + item.id"
              >
                <MDDropdown
                  v-if="item.type == 2"
                  v-bind:group="item.mdid"
                  v-model="item.value"
                ></MDDropdown>
              </b-form-group>
            </div>
          </b-modal>
        </div>
        <b-table
          responsive
          id="my-table"
          striped
          :items="report.datas"
          :fields="report.fields"
          :per-page="20"
          :current-page="currentPage"
        >
          <template v-slot:cell(action)="row">
            <b-link
              variant="success"
              :href="'#' + item.link + '/' + row.item.id"
              v-for="item in getButtons(2)"
              v-bind:key="item.id"
              >{{ item.title }}</b-link
            >
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          per-page="20"
          aria-controls="my-table"
        ></b-pagination>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelpoer from "../helpers/httpHelper";
import sessionHelper from "@/helpers/sessionHelper";
import MDDropdown from "./MDDropdown";
export default {
  name: "Reporter",
  data: function() {
    return {
      currentPage: 1,
      lastPage: 0,
      total: 0,
      report: {
        fields: [],
        datas: [],
        params: [],
        Buttons: [],
      },
    };
  },
  watch: {
    "$route.params.id": function(oldval, newval) {
      this.report = {
        fields: [],
        datas: [],
        params: [],
        Buttons: [],
      };
      this.getReport();
    },
  },
  created() {
    this.getReport();
  },
  methods: {
    getReport: function() {
      httpHelpoer.getData("rp/" + this.$route.params.id).then((res) => {
        if (res.success) {
          this.report.title = res.result.title;
          this.$store.dispatch(SET_BREADCRUMB, [{ title: this.report.title }]);
          this.report.params = res.result.params;
          this.report.Buttons = res.result.buttons;
          this.report.fields = res.result.fields.map((element) => {
            return {
              key: element.field,
              label: element.title,
            };
          });
          this.report.fields.push({
            key: "action",
            label: "عملیات",
          });
          this.getData();
        }
      });
    },
    getData: function() {
      httpHelpoer.setAuth();
      httpHelpoer
        .postData("rp/" + this.$route.params.id, { param: this.report.params })
        .then((res) => {
          if (res.success == true) {
            this.report.datas = res.result;
          }
        });
    },
    pageChanged: function(page) {
    },
    getButtons: function(place) {
      var btns = [];
      for (let i = 0; i < this.report.Buttons.length; i++) {
        const element = this.report.Buttons[i];
        if (element.place == place) {
          btns.push(element);
        }
      }
      return btns;
    },
  },
  computed: {
    rows() {
      return this.report.datas.length;
    },
  },
  components: { MDDropdown },
  mounted() {},
};
</script>
